import type { User } from '@/types';

export type AccountInformationFormValues = Partial<
    Pick<
        User,
        | 'bio'
        | 'calendarLink'
        | 'companyName'
        | 'companyWebsite'
        | 'emailAddress'
        | 'firstName'
        | 'lastName'
        | 'title'
        | 'username'
    >
>;

export const buildAccountInformationUpdate = (
    values: AccountInformationFormValues,
    companyWebsite: User['companyWebsite'],
): AccountInformationFormValues => ({
    bio: values.bio,
    calendarLink: values.calendarLink,
    companyName: values.companyName,
    companyWebsite,
    emailAddress: values.emailAddress,
    firstName: values.firstName,
    lastName: values.lastName,
    title: values.title,
    username: values.username,
});
